import { type AppointmentDate } from '../types';

export const findFirstAvailableAppointment = (
  appointments: AppointmentDate[]
) =>
  appointments.find(
    (appointment) =>
      !appointment?.isDisabled && appointment?.availableTimes?.length > 0
  );
